/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

const baseStyles = css`
    width: 100%;
    margin-bottom: var(--layout-spacing-12);

    .search-filter {
        margin: 0;
    }
`;

export const styles = () => css`
    ${baseStyles}
`;
